import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Avatar from "../../components/inputs/Avatar";
import { arabicMonthes } from "../../utils/arabicDatesUtilities.js";
import { useTranslation } from "react-i18next";
import { useUpdateLearningTrackMutation } from "../../services/organization/adminLearningTrack";
import ConfirmationModal from "../Modals/ConfirmationModal";
import LearningPathCardImage from "./LearningPathCardImage";

export default function AdminLearningPathCard({
  track,
  modalId,
  setModalTrack,
  disableNavigation,
}) {
  const [isOpen, setIsOpen] = useState(true);
  const navigate = useNavigate();

  const [updateLearningTrack] = useUpdateLearningTrackMutation();

  const createdAt = new Date(track.created_at);
  const { t, i18n } = useTranslation(["learningPaths"]);
  const englishMonths = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const createdAtLabel =
    i18n.language === "ar"
      ? `${createdAt.getDate()} ${arabicMonthes[createdAt.getMonth()]} ${createdAt.getFullYear()}`
      : `${createdAt.getDate()} ${englishMonths[createdAt.getMonth()]} ${createdAt.getFullYear()}`;

  function moreThanTwoEnrollers() {
    return track.enrollments_count > 2;
  }

  function remainingEnrollersCount() {
    return track.enrollments_count - 2;
  }

  function openDetails(e) {
    if (disableNavigation) return;
    navigate(`/admin/learning_paths/${track.id}`);
  }

  function openModal(e) {
    e.nativeEvent.stopImmediatePropagation();
    e.stopPropagation();
    setModalTrack(track);
  }

  return (
    <div onClick={openDetails} className="card-style admin-learinig-path-card">
      {!disableNavigation && (
        <ConfirmationModal
          confirmationMessage={t("learningPaths:confirmLearningTrackDelete")}
          handleConfirmation={async (e) => {
            e.stopPropagation();
            await updateLearningTrack({
              learningTrackId: track.id,
              body: {
                archived: true,
              },
            });
            setIsOpen(false);
          }}
          isOpened={isOpen}
          onClose={(e) => {
            e.stopPropagation();
            setIsOpen((status) => !status);
          }}
        >
          <p className="text-danger">
            - {t("learningPaths:actionIrreversible")}
          </p>
          <p className="text-danger">- {t("learningPaths:willNotAppear")}</p>
          <p className="text-danger">
            - {t("learningPaths:cannotAccessTrack")}
          </p>
        </ConfirmationModal>
      )}

      <LearningPathCardImage src={track.image_url} alt={track.title} />

      <div className="admin-learinig-path-card__content w-100">
        <div className="admin-learinig-path-card__header">
          <p className="card-title admin-learinig-path-card__title">
            {track.title}
          </p>
          {!track?.archived && !disableNavigation ? (
            <div className="admin-learinig-path-card__card-actions">
              <button
                onClick={openModal}
                type="button"
                className="btn btn-grey-color font-15"
                data-bs-toggle="modal"
                data-bs-target={`#${modalId}`}
              >
                <span className="fas fa-share fa-fw me-2"></span>
                {t("learningPaths:inviteEmployee")}
              </button>

              <div className="dots-tools">
                <div className="dropdown tools">
                  <button
                    type="button"
                    className="btn btn-grey-color font-15 admin-learinig-path-card__menu-btn"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <span className="fas fa-ellipsis-h fa-fw font_14 font-color-grey"></span>
                  </button>
                  <ul
                    className="dropdown-menu dropdown-menu-end"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li>
                      <button
                        type="button"
                        className="bold mb-0 font_12 font-extrabold"
                        data-bs-toggle="modal"
                        data-bs-target="#confirmation-modal"
                        onClick={(e) => e.stopPropagation()}
                      >
                        {t("learningPaths:deleteTrack")}
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          ) : !disableNavigation ? (
            <div className="admin-learinig-path-card__card-actions">
              <button type="button" className="btn btn-grey-color font-15">
                {t("learningPaths:deletedTrack")}
              </button>
            </div>
          ) : null}
        </div>

        <p className="card-detail">
          {t("learningPaths:courses", { courses_count: track.courses_count })}
        </p>

        <div className="admin-learinig-path-card__meta">
          <div className="admin-learinig-path-card__enrollees">
            {track.users?.length > 0 && (
              <ul className="avatar-group me-2">
                {track.users.map((user) => (
                  <li key={`track-${track.id}-user-avatar-${user.id}`}>
                    <Avatar width="30" height="30" avatarUrl={user.avatar_url} />
                  </li>
                ))}

                {moreThanTwoEnrollers() && (
                  <li key={`track-${track.id}-users-number`}>
                    <div className="avatar-group-total" width="30" height="30">
                      +{remainingEnrollersCount()}
                    </div>
                  </li>
                )}
              </ul>
            )}
            <p className="m-0 font_12 font-bold">
              {track.enrollments_count} {t("learningPaths:enrolledUsers")}
            </p>
          </div>

          <p className="card-date admin-learinig-path-card__date">
            {t("learningPaths:trackCreationDate")} {createdAtLabel}
          </p>
        </div>
      </div>
    </div>
  );
}
